import { useSelector } from 'react-redux';
import has from 'lodash/has';
import { RESOURCE_NOTIFICATIONS_PAGINATED } from 'js/constants/paginationEntitiesTypes';
import map from 'lodash/map';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import {
  DELETE_RESOURCE_NOTIFICATION_REQUEST,
  GET_RESOURCE_NOTIFICATIONS_REQUEST,
} from 'js/constants/actionTypes';

export function useResourceNotifications(type, id) {
  const { data } = useSelector((state: any) => state?.pagination);
  const loading = useIsLoading(
    GET_RESOURCE_NOTIFICATIONS_REQUEST,
    DELETE_RESOURCE_NOTIFICATION_REQUEST,
  );

  if (has(data, [RESOURCE_NOTIFICATIONS_PAGINATED, type, id])) {
    let pageData = data[RESOURCE_NOTIFICATIONS_PAGINATED][type][id].data;
    const items = map(pageData.ids, (id) => pageData.items[id]);
    const meta = data[RESOURCE_NOTIFICATIONS_PAGINATED][type][id].meta;
    return { items, meta, loading };
  }
  return { items: [], meta: {}, loading: false };
}
